import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { useOpenEventPanel } from '../event-panel/use-open-event-panel';

export function EditEventItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: EventContextMenuClickParams;
}): React.ReactElement {
    const openEventPanel = useOpenEventPanel();
    const handleSelect = (): void => {
        openEventPanel({ eventId: clickParams.eventId });
    };

    return (
        <ContextMenuItem
            dataTrackId="menu-item-edit-event"
            contextMenuItemView={contextMenuItemView}
            onSelect={handleSelect}
        />
    );
}
